import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardGoalProgressRing } from "web_myplann/Dashboard/Components/DashboardGoalProgressRing";
import { DashboardGoalsCardItem } from "web_myplann/Dashboard/Components/DashboardGoalsCardItem";
import type { GoalOverviewItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	goals: GoalOverviewItemResponseDTO[];
};

export const DashboardGoalsList: FC<Props> = ({ goals }) => {
	const { t } = useResource();
	const navigate = useNavigate();

	return (
		<>
			{goals.map((goal) => (
				<DashboardGoalsCardItem
					key={goal.id}
					ring={
						<DashboardGoalProgressRing
							progress={goal.coveredPercent}
							category={goal.investmentPlanCategoryType}
						/>
					}
					value={t(Resources.Dashboard.GoalsCard.percent, {
						percent: goal.coveredPercent,
					})}
					label={goal.name ?? ""}
					onClick={() =>
						navigate(Routing.Goals.GoalDetail.path(String(goal.id)))
					}
				/>
			))}
		</>
	);
};
